"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpModalDialog = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
class CmpModalDialog extends tmpls_1.CmpModalDialogBase {
    static DialogOkNoCancel(text, title = "Information") {
        const dialog = new CmpModalDialog();
        dialog.ctrls.lText.text = text;
        dialog.ctrls.lTitle.text = title;
        return dialog;
    }
    static DialogOk(text, title = "Information") {
        const dialog = CmpModalDialog.DialogOkNoCancel(text, title);
        dialog.ctrls.btnNo.hide();
        dialog.ctrls.btnCancel.hide();
        return dialog;
    }
    static DialogOkNo(text, title = "Information") {
        const dialog = CmpModalDialog.DialogOkNoCancel(text, title);
        dialog.ctrls.btnNo.hide();
        dialog.ctrls.btnCancel.hide();
        return dialog;
    }
    constructor() {
        super();
        this.ctrls.background.onclick = () => this._execute();
        this.ctrls.btnClose.onclick = () => this._execute();
        this.ctrls.btnCancel.onclick = () => this._execute();
        this.ctrls.btnOk.onclick = () => this._execute(true);
        this.ctrls.btnNo.onclick = () => this._execute(false);
        this.ctrls.lText.onclick = (e) => e.stopPropagation();
    }
    showAndWaitAsync() {
        gs.q('body').first.append(this);
        return new Promise((resolve) => {
            this._resolve = resolve;
        });
    }
    show() {
        gs.q('body').first.append(this);
        super.show();
    }
    _execute(result = undefined) {
        this.cut();
        if (this._resolve)
            this._resolve(result);
    }
}
exports.CmpModalDialog = CmpModalDialog;
//# sourceMappingURL=CmpModalDialog.js.map